import { useCurrentUser } from 'store/api/yay/user'

export const useIsSelfUser = (userId) => {
  const currentUserId = useCurrentUser()?.data?.id

  return userId && currentUserId && userId === currentUserId
}
